import { useQuery } from "react-query";
import { useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";

const fetchEligibility = async ({ token, email, phone, orderTotal }) => {
  const params = {};
  if (email) params.email = email.trim().toLowerCase();
  if (phone) params.phone = phone.trim();
  if (orderTotal != null) params.orderTotal = orderTotal;

  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/order/pay-on-delivery-eligibility/me`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params,
    }
  );
  return response.data;
};

/** Pay-on-delivery eligibility — signed-in customers only. */
const usePayOnDeliveryEligibility = (email = "", phone = "", orderTotal = null) => {
  const { token, isLoggedIn } = useContext(AuthContext);

  return useQuery(
    ["payOnDeliveryEligibility", email, phone, orderTotal],
    () =>
      fetchEligibility({
        token,
        email,
        phone,
        orderTotal,
      }),
    {
      enabled: !!isLoggedIn && !!token,
      staleTime: 45_000,
      retry: 1,
      keepPreviousData: true,
    }
  );
};

export default usePayOnDeliveryEligibility;
